// Cómo se escriben los números en todo el programa.
//
// En un solo sitio porque una cifra que se ve distinta según la pantalla hace
// dudar de si es la misma cifra.

export const plata = (n) => '$' + Math.round(n || 0).toLocaleString('es-CO');

// Las cantidades llevan decimales solo cuando los tienen: «20 láminas» se lee
// mejor que «20,00 láminas», y «2,5 metros» necesita el suyo.
export const cant = (n, unidad = '') => {
  const v = Number(n) || 0;
  const texto = Number.isInteger(v) ? v.toLocaleString('es-CO')
                                    : v.toFixed(2).replace('.', ',');
  return unidad ? `${texto} ${unidad}` : texto;
};

export const fecha = (f) => {
  if (!f) return '—';
  const d = new Date(String(f).length <= 10 ? f + 'T00:00:00' : f);
  return isNaN(d) ? '—' : d.toLocaleDateString('es-CO',
    { day: 'numeric', month: 'short', year: 'numeric' });
};

export const hoy = () => new Date().toISOString().split('T')[0];

export const primeroDelMes = () => {
  const d = new Date(); d.setDate(1);
  return d.toISOString().split('T')[0];
};

// Buscar productos por código, nombre o referencia, sin importar tildes ni
// mayúsculas. Quien busca un tornillo teclea «tor» o «3/8», no el nombre
// completo con su tilde.
export const normalizar = (t) => (t || '').toString().toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const buscar = (lista, texto, campos = ['codigo', 'nombre', 'referencia']) => {
  const q = normalizar(texto).trim();
  if (!q) return lista;
  return lista.filter(x => campos.some(c => normalizar(x[c]).includes(q)));
};
